import { useTranslation } from 'react-i18next';
import { Typography } from 'styles';
import { TRANSLATION_KEYS } from 'utils/constants';

type Props = {
	message?: string;
};

const ComplaintErrorMessage = ({ message }: Props) => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});

	return (
		<Typography
			variant="caption"
			color={theme => theme.palette.error.main}
			position={'absolute'}
			bottom={-22}
			left={12}
		>
			{message || tClientLabels('complaint.errorMessageField')}
		</Typography>
	);
};

export default ComplaintErrorMessage;
